import React from "react";
import { Modal, Image } from "react-bootstrap";
import { formatMomentDate } from "../../../utils/dateHelper";
import { useNavigate } from "react-router-dom";
import withModal from "../../../components/withModal";
import { routes } from "../../../routes/pageRoutes";

const ViewBulkOfferRequestModalInner = ({ data }) => {
    const navigate = useNavigate();

    if (!data) return null;

    const company = data?.company || {};
    const creator = company?.creator || {};

    const goToCompany = () => company?.id && navigate(routes.viewCompany.replace(":id", company.id));
    const goToUser = () => creator?.id && navigate(routes.viewUser.replace(":id", creator.id));

    return (
        <Modal.Body className="grid row-gap-4">
            
                <div className="g-col-6">
                    <h6 className="text-secondary text-uppercase mb-3 small fw-bold">Company Information</h6>
                    <div className="d-flex align-items-center gap-3">
                        {company?.profile?.logo?.url ? (
                            <Image src={company.profile.logo.url} width={60} height={60} roundedCircle className="object-fit-cover shadow-sm cursor-pointer" onClick={goToCompany} />
                        ) : (
                            <div className="rounded-circle bg-light d-flex align-items-center justify-content-center border cursor-pointer" style={{ width: 60, height: 60, fontSize: 14 }} onClick={goToCompany}>Logo</div>
                        )}
                        <div>
                            <h5 className="mb-1 fw-bold cursor-pointer" onClick={goToCompany}>{company.name || "-"}</h5>
                            <p className="mb-0 text-secondary">{company?.profile?.mobile_number || "-"}</p>
                        </div>
                    </div>
                </div>
                <div className="g-col-6">
                    <h6 className="text-secondary text-uppercase mb-3 small fw-bold">Requester Information</h6>
                    <div className="d-flex align-items-center gap-3">
                        {creator?.profile?.profile_photo?.url ? (
                            <Image src={creator.profile.profile_photo.url} width={60} height={60} roundedCircle className="object-fit-cover shadow-sm cursor-pointer" onClick={goToUser} />
                        ) : (
                            <div className="rounded-circle bg-light d-flex align-items-center justify-content-center border cursor-pointer" style={{ width: 60, height: 60, fontSize: 14 }} onClick={goToUser}>
                                {creator?.first_name ? creator.first_name[0] : "U"}
                            </div>
                        )}
                        <div>
                            <h5 className="mb-1 fw-bold cursor-pointer" onClick={goToUser}>{creator.first_name} {creator.last_name}</h5>
                            <p className="mb-0 text-secondary small">{creator?.profile?.profession?.name || "-"}</p>
                            <p className="mb-0 text-secondary">{creator.mobile_number || "-"}</p>
                        </div>
                    </div>
                </div>
                
                    <hr className="my-2 g-col-12" />
                
                <div className="g-col-12">
                    <h6 className="text-secondary text-uppercase mb-2 small fw-bold">Description</h6>
                    <div className="bg-light p-3 rounded-2 border">
                        <p className="mb-0 text-primary-emphasis lh-base" style={{ whiteSpace: "pre-wrap" }}>
                            {data.description || "No description provided."}
                        </p>
                    </div>
                </div>
                <div className="g-col-12 text-end text-secondary small">
                    Requested on: <strong>{data.created_at ? formatMomentDate(data.created_at, "DD MMM YYYY, hh:mm A") : "-"}</strong>
                </div>
            
        </Modal.Body>
    );
};

const ViewBulkOfferRequestModal = withModal(ViewBulkOfferRequestModalInner);

export default ViewBulkOfferRequestModal;
